import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=0d0058cb&scoped=true"
import script from "./ProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileImage.vue?vue&type=script&lang=js"
import style0 from "./ProfileImage.vue?vue&type=style&index=0&id=0d0058cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0058cb",
  null
  
)

export default component.exports